import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ThemeToggle } from '../primitives'
import { useReducedMotion } from '../../../hooks/useReducedMotion'
import { navSlideDown, buttonHover, buttonTap, reduceMotion } from '../../../utils/animations'
import { useTheme } from '../../../contexts/ThemeContext'
import candlefishLogoLight from '../../../assets/Candlefish Long Light Mode.png'
import candlefishLogoDark from '../../../assets/Candlefish Long Dark Mode.png'

export default function Navigation() {
  const { resolvedTheme } = useTheme()
  const prefersReducedMotion = useReducedMotion()
  const [scrolled, setScrolled] = useState(false)
  const slideDownVariant = prefersReducedMotion ? reduceMotion : navSlideDown

  const candlefishLogo = resolvedTheme === 'dark' ? candlefishLogoDark : candlefishLogoLight

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <motion.nav
      id="navigation"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/40 dark:bg-black/40 backdrop-blur-sm border-b border-neutral-200 dark:border-neutral-800'
          : 'bg-transparent'
      }`}
      initial="hidden"
      animate="visible"
      variants={slideDownVariant}
    >
      <div className="px-5 sm:px-7 py-3 md:py-4">
        <div className="flex items-center justify-between gap-1">
          {/* Logo */}
          <motion.div
            whileHover={prefersReducedMotion ? {} : buttonHover}
            whileTap={prefersReducedMotion ? {} : buttonTap}
            className="flex-shrink-0 min-w-0"
          >
            <Link to="/" className="block -my-2 py-2 transition-opacity hover:opacity-80">
              <img
                src={candlefishLogo}
                alt="Candlefish"
                width={800}
                height={176}
                decoding="async"
                className="h-7 sm:h-8 w-auto"
              />
            </Link>
          </motion.div>

          <div className="flex-shrink-0">
            <ThemeToggle />
          </div>
        </div>
      </div>
    </motion.nav>
  )
}
